import styled from 'styled-components';

// Components
import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Icon = styled.img`
  width: 7.8rem;
  height: 7.8rem;

  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    width: 6rem;
    height: 6rem;
  }
`;

export const Title = styled(Typography)`
  text-align: center;
  font-size: 2.6rem;
  padding: 3rem 5.9rem;
`;

export const ProgressText = styled(Typography)`
  text-align: center;
  font-size: 1.6rem;
  margin: 1rem 0;
  color: ${({ theme }) => theme.colors.greyDark};
`;

export const Button = styled(MainButton)`
  margin-top: 1.6rem;
  padding: 0.75rem 2rem;
  p {
    font-size: 1.8rem;
  }
`;

